import React, { Component } from 'react'
import axios from 'axios'
import ModalVideo from 'react-modal-video'
import { t } from 'i18n'

const ConfirmModal = ({ isOpen, onConfirm, onCancel }) => {
  if (!isOpen) return null;
  return (
    <div id="cc--video-confirm" className="c--anim">
      <div id="cc--video-confirm_div" className="cc--video-confirm_div">
        <div className="cm bar top center slide">
          <div className="c-inr">
            <div className="c-inr-i">
              <h2 className="video-ttl">
                {t('main.videos.external_video_title')}
              </h2>
              <div
                className="video-txt"
                dangerouslySetInnerHTML={{
                  __html: t('main.videos.external_video_text')
                }}
              />
            </div>
            <div className="c-bns">
              <button type="button" className="c-bn c-p-bn" onClick={onConfirm}>
                {t('main.videos.continue')}
              </button>
              <button type="button" className="c-bn c-s-bn c_link" onClick={onCancel}>
                {t('main.videos.close')}
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Backdrop */}
      <div
        className="cm-ov"
        onClick={onCancel}
      />
    </div>
  );
};

class VideoCardsBlock extends Component {
  constructor(props) {
    super(props)
    this.state = {
      videos: JSON.parse(props.passedVideos),
      isLoading: false,
      modalVideoId: null,
      modalIsOpen: false,
      confirmModalOpen: false,
      pendingVideoId: null
    }
    this.fetchMoreVideos = this.fetchMoreVideos.bind(this)
    this.openModal       = this.openModal.bind(this)
    this.closeModal      = this.closeModal.bind(this)
    this.handleConfirm    = this.handleConfirm.bind(this)
  }
  videosParams() {
    const { videos } = this.state
    return {
      offset_id: videos[videos.length -1].id,
    }
  }

  fetchMoreVideos() {
    const { videos } = this.state

    this.setState({isLoading: true})
    axios.get(`/videos.json`, { params: this.videosParams() }).then( (response) => {
      if (response.status == 200){
        let newVideos = videos
        for(let video of response.data) {
          newVideos.push(video)
        }
        this.setState({videos: newVideos})
      }
      this.setState({isLoading: false})
    })
  }

  openModal(e, videoId) {
    e.preventDefault()
    this.setState({
      confirmModalOpen: true,
      pendingVideoId: videoId
    })
  }

  closeModal() {
    this.setState({
      modalIsOpen: false,
      confirmModalOpen: false
    })
  }

  handleConfirm() {
    const videoId = this.state.pendingVideoId;
    const url = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
    window.open(url, '_blank');
    this.setState({
      confirmModalOpen: false,
      pendingVideoId: null
    });
  }

  handleCancel = () => {
    this.setState({
      confirmModalOpen: false,
      pendingVideoId: null
    })
  }

  renderVideo(video) {
    return(
      <div className='col-lg-4 col-md-6 col-sm-12 col-12 custom-card' key={video.id}>
        <a href='#' onClick={(e) => this.openModal(e, video.video_id)}>
          <div className='image-container'>
            <div className='card-img-top custom-card-image'>
              <img src={video.thumbnail_url} />
            </div>
          </div>
          <div className='card-block'>
            <div className='title'>
              {video.title}
            </div>
          </div>
        </a>
      </div>
    )
  }

  renderShowMoreButton() {
    if(this.props.noMoreButton || this.state.videos.length == this.props.totalCount) {
     return
    }
    if(this.state.isLoading){
      return(
        <span className='loading-indicator'></span>
      )
    } else {
      return (
        <span onClick={this.fetchMoreVideos} className='btn main-page-button'>
          {t('main.videos.more')}
        </span>
      )
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.confirmModalOpen && !prevState.confirmModalOpen) {
      document.documentElement.classList.add('force--video-confirm', 'show--video-confirm');
    } else if (!this.state.confirmModalOpen && prevState.confirmModalOpen) {
      document.documentElement.classList.remove('force--video-confirm', 'show--video-confirm');
    }
  }

  componentWillUnmount() {
    // Clean up in case modal is still open when component unmounts
    document.documentElement.classList.remove('force--video-confirm', 'show--video-confirm');
  }

  render() {
    const videos = this.state.videos.map(video => this.renderVideo(video))

    return(
      <div id='videos-cards'>
        <div className='container'>
          <div className='row'>
            {videos}
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="text-center col-12 main-page-button-container">
              {this.renderShowMoreButton()}
            </div>
          </div>
        </div>
        <ConfirmModal
          isOpen={this.state.confirmModalOpen}
          onConfirm={this.handleConfirm}
          onCancel={this.handleCancel}
        />
        <ModalVideo
          channel='custom'
          isOpen={this.state.modalIsOpen}
          url={`https://www.youtube.com/embed/${this.state.modalVideoId}?autoplay=1`}
          onClose={() => this.setState({modalIsOpen: false})}
        />
      </div>
    )
  }
}

export default VideoCardsBlock
